<script>
import { debounce } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
export default {
  mixins: [MixPanel],

  data() {
    return {
      filter: '',
      section: 'all',
    }
  },

  computed: {
    menuList() {
      return this.$store.state.marketplace.sideMenu
    },
  },
  methods: {
    searchData: debounce(function () {
      this.onFiltered()
    }, 500),

    async changeTab(menu) {
      this.section = menu.section
      this.track(`Click Marketplace Product Category`, {
        category: menu.section,
      })
      await this.$emit('marketplaceTab', menu)
    },

    onFiltered() {
      this.$emit('searchMarketplace', this.filter)
    },
  },
}
</script>

<template>
  <b-card class="mc-marketplace-sidebar__module">
    <b-form-input
      v-model="filter"
      type="search"
      :placeholder="$t('global.search') + '...'"
      @input="searchData"
    />

    <div class="mc-marketplace-sidebar__module-list">
      <ul class="list-unstyled">
        <li
          v-for="item in menuList"
          :key="item.section"
          :class="{ active: section === item.section }"
        >
          <a
            href="javascript:void(0);"
            class="d-flex align-items-center justify-content-between"
            @click="changeTab(item)"
          >
            <span class="mc-marketplace-sidebar__module-list-label">{{ $t(item.label) }}</span>
            <span class="mc-marketplace-sidebar__module-list-pill">
              {{ item.total }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </b-card>
</template>
